module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"campaigns":"Aktionen","new":"Neu"},"en":{"campaigns":"Campaigns","new":"New"}}')
  delete Component.options._Ctor
}
